import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

$(document).ready(function(){
  if($('#shop-circle-ani').length > 0){
    var t1 = getRandomInt(20, 30);
    var r1 = getRandomInt(30, 120);
    var t2 = getRandomInt(140, 150);
    var r2 = getRandomInt(30, 120);
    $('#shop-circle-ani .circle-bg-img.circle1').css({top: t1+'%',right: r1+'%'})
    $('#shop-circle-ani .circle-bg-img.circle2').css({top: t2+'%',right: r2+'%'})
    var mo = new MutationObserver(function(records){
      if($(records[0].target).hasClass('is-inview')){
        t1 = getRandomInt(20, 50);
        r1 = getRandomInt(30, 120);
        t2 = getRandomInt(120, 150);
        r2 = getRandomInt(30, 120);
        $('#shop-circle-ani .circle-bg-img.circle1').css({top: t1+'%',right: r1+'%'})
        $('#shop-circle-ani .circle-bg-img.circle2').css({top: t2+'%',right: r2+'%'})
      }
    });
    
    var element = document.getElementById('shop-circle-ani');
    mo.observe(element, {'attributes': true});
  }

  $('.section1 .common-more').on('click',function(){
    $('.section1 .intent-fixed').addClass('active')
    if($(window).width() < 992){
      $('body').css({
        'height':'100vh',
        'overflow-y':'hidden'
      })
    }
  })
  $('.section1 .intent-fixed .close-btn').on('click',function(){
    $('.section1 .intent-fixed').removeClass('active')
    $('body').css({
      'height':'auto',
      'overflow-y':'auto'
    })
  })
})

var swiper2 = new Swiper(".section1 .mySwiper2", {
  speed: 600,
  centerInsufficientSlides: true,
  slidesPerView: 'auto'
})
var swiper1 = new Swiper(".section1 .mySwiper1", {
  speed: 600,
  on:{
    init: function(swiper){
      swiper2.slideTo(0)
      $('.section1 .mySwiper2 .swiper-slide').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      swiper2.slideTo(this.realIndex)
      $('.section1 .mySwiper2 .swiper-slide').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
})
$('.section1 .mySwiper2 .swiper-slide').on('click',function(){
  let index = $(this).index()
  swiper1.slideTo(index)
})


// 生成随机数
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
